var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.99 63.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "MAIN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.38,20a4.08,4.08,0,1,1,8.15,0,4.08,4.08,0,1,1-8.15,0Zm6,0a2,2,0,1,0-3.87,0,2,2,0,1,0,3.87,0Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.51,19v4.92h-1.9V16h2.23l2.91,4.57V16h1.91v7.9h-2Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.42,35.94v-6H13V28h6.92v1.89H17.5v6Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,32A4.08,4.08,0,1,1,24,36.11,4,4,0,0,1,20,32Zm6,0a2,2,0,1,0-3.88,0A2,2,0,1,0,26,32Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.76,35.94V34.28l3.78-4.44H28.72V28h6.37v1.7l-3.8,4.41H35.2v1.79Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,35.94H36.38V28H41.9v1.81H38.46V31h3.12v1.81H38.46v1.35H42Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.57,35.94l2.42-4L42.85,28h2.42l1.31,2.61L48,28h2.32L48.11,32l2.38,3.95H48l-1.49-2.71L45,35.94Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.77,44a4.08,4.08,0,1,1,4.07,4.13A4,4,0,0,1,16.77,44Zm6,0a2,2,0,1,0-3.87,0,2,2,0,1,0,3.87,0Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9,43v4.92H26V40h2.24l2.91,4.57V40h1.91v7.9H31Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.59,47.94V40h2.07v6H40v1.88Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.21,47.94H42.13V45L39.37,40h2.24l1.63,3,1.66-3H47L44.21,45Z",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "NAV"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.47,13.82l-5-2.09A30.93,30.93,0,0,0,1,29.67l5,2.09A25.92,25.92,0,0,1,13.47,13.82Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,31.87l5-2.09a30.94,30.94,0,0,0-7.38-18l-5,2.1A25.86,25.86,0,0,1,58,31.87Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,32.31,1,34.4A31,31,0,0,0,8.46,52.3l5-2.09A25.93,25.93,0,0,1,6,32.31Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27,13.53l2.1-5a30.93,30.93,0,0,0-18-7.5L32.26,6A25.86,25.86,0,0,1,50.27,13.53Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7,6,29.61,1A31,31,0,0,0,11.75,8.45l2.09,5A25.85,25.85,0,0,1,31.7,6Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.89,50.59l-2.1,5A31,31,0,0,0,29.56,63l2.09-5A25.85,25.85,0,0,1,13.89,50.59Z",
    style: {
      fill: "#000000"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.363198e54813fe03929292baf257790e.svg";
export { ForwardRef as ReactComponent };